import type { TaskTrackingSummary } from '@/lib/types';

const MAX_REASON_LENGTH = 250;

/**
 * Decide whether a rise in the ad-sync failure count should be announced, and what to say.
 *
 * `seenFailed` is null before the first summary arrives: that first reading becomes the
 * baseline so a failure that predates this page view does not toast on every open (#6297).
 */
export function nextFailureAnnouncement(
  seenFailed: number | null,
  summary: TaskTrackingSummary,
): { seenFailed: number; message: string | null } {
  if (seenFailed === null || summary.failed <= seenFailed) {
    return { seenFailed: seenFailed === null ? summary.failed : seenFailed, message: null };
  }
  const reason = summary.latest_error_message?.trim();
  const truncated = reason && reason.length > MAX_REASON_LENGTH ? `${reason.slice(0, MAX_REASON_LENGTH)}…` : reason;
  return {
    seenFailed: summary.failed,
    message: truncated
      ? `Couldn't save these changes to Google Ads. Reason: ${truncated}`
      : "Couldn't save these changes to Google Ads. Please try again.",
  };
}
